<template>
	<v-sheet flat>
		<mw-edit :id="id" storeModule="users" :model="model" title-field="name">
			<template v-slot:email="slotProps">
				<v-text-field
					v-model="slotProps.data.email"
					:label="$t('misc.email')"
					@input="(v) => (slotProps.data['email'] = parseEmail(v))"
					:rules="[(v) => mwutils.validateEmail(v) || 'Invalid Email']"
				></v-text-field>
			</template>
			<template v-slot:append>
				<mw-select-or-create
					:multiple="false"
					v-model="user.organisation"
					storeModule="organisations"
					label="Organisation"
				></mw-select-or-create>
			</template>
		</mw-edit>
		<secondary-navigation>
			<template v-slot:main>
				<div v-if="id" class="ma-2">
					<nav-item
						:link="`/communication-history/${id}`"
						text="Communication History"
						icon="mdi-email"
					></nav-item>
					<v-divider class="mb-4 mt-3"></v-divider>
					<send-email-button
						class="mb-5"
						:values="{ site_url: 'https://research.m.works', user: id }"
						email="registration_reminder"
					>
						<template v-slot:button="scope">
							<v-btn block small @click="scope.click" color="primary">
								Send Email Reminder
							</v-btn>
						</template>
					</send-email-button>
				</div>
			</template>
		</secondary-navigation>
		<!-- <v-btn color="green" dark link target="_blank" :to="`/support/${id}`">Provide Video Support</v-btn> -->
	</v-sheet>
</template>

<style lang="less"></style>

<script type="text/javascript">
import User from "@/models/User";
import MwEdit from "@c/ui/MwEdit";
import SendEmailButton from "@c/communication/SendEmailButton";
import SecondaryNavigation from "@c/navigation/Secondary";
import NavItem from "@/components/navigation/Item";
import MwSelectOrCreate from "../ui/MwSelectOrCreate.vue";

export default {
	name: "EditClient",
	props: {
		id: { type: String }, // @doc the id string of the object - will add a new document if not passed
	},
	computed: {
		model() {
			return User;
		},
		user() {
			return this.$store.state.users.data[this.id];
		},
	},
	methods: {
		parseEmail(a) {
			return a.toLowerCase().trim();
		},
	},
	components: {
		MwEdit,
		SendEmailButton,
		SecondaryNavigation,
		NavItem,
		MwSelectOrCreate,
	},
};
</script>
